// const searchBox = document.querySelector(".st-desktop-searchbox");

//   if (!searchBox) return;

//   const observer = new MutationObserver(() => {
//     const autocompleteWrapper = document.querySelector(".wizzy-autocomplete-wrapper");
//     if (autocompleteWrapper) {
//       const rect = searchBox.getBoundingClientRect();
//       const rightOffset = window.innerWidth - rect.right;

//       autocompleteWrapper.style.position = "absolute";
//       autocompleteWrapper.style.right = rightOffset + "px";

//       observer.disconnect(); // stop observing once applied
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });

async function addToCart(productId, quantity, btn) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: productId,
              quantity: quantity,
            }),
        });

        if (!response.ok) {
          throw new Error('Error adding to cart');
        }

        const data = await response.json();
        // Display a success message
        // console.log('Add to Cart Response:', data);
        
        updatecart('/', btn);
        let close_btn = document.querySelector('.multi-popup-close');
        if(close_btn)
        {
          close_btn.click();
        }
        //Removed active classes from popup and button
        let featureWrapper = btn.parentNode.querySelector('.multi-variant-popup-wrapper');
        // console.log("featureWrapper", featureWrapper, btn);
        if (featureWrapper) {
          featureWrapper.classList.remove('open');
          setTimeout(() => {
            featureWrapper.classList.remove('active');
          }, 700);
          document.querySelector("html.js").style.removeProperty("overflow");
          btn.classList.remove('btn-loading');
        }
    } catch (error) {
      // Display error message
      btn.classList.remove("loading");
      // console.error('Add to Cart Error:', error);
    }
}
function updatecart(url, btn) {
  fetch(url).then(function (response) {
    // The API call was successful!
    return response.text();
  }).then(function (html) {
    // Convert the HTML string into a document object
    // console.log("html", html);
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    btn.classList.remove("loading");
    document.querySelector(".cart-icon-wrapper").click();
    document.querySelector(".cart-icon-wrapper").innerHTML = doc.querySelector(".cart-icon-wrapper").innerHTML;
    document.querySelector('.side-cart-panel').innerHTML = doc.querySelector(".side-cart-panel").innerHTML;
    
  }).catch(function (err) {
    // There was an error
    // console.warn('Something went wrong.', err);
  }).finally(() => {
    // Remove loading class from button
    // window.initProductRxcommendationsSlider();
  });
}
const variantChange = (parent) => {
      let options = [];
      // console.log("Inside Variant change");
      let atc_btn = document.querySelector('.variant-quick-add-cart-js');
      let currentVariant = document.querySelector('variant-radios input:checked');
      // console.log("currentVariant",currentVariant);
      if(currentVariant.getAttribute("is-available") === "true")
      {
        let price = currentVariant.getAttribute('data-price');
        atc_btn.setAttribute("data-price", price);
        let id = currentVariant.getAttribute("id");
        atc_btn.setAttribute("data-vid", id);
        atc_btn.removeAttribute('disabled');
        atc_btn.innerText = "ADD TO CART";
      }
      else
      {
        atc_btn.setAttribute('disabled', '');
        atc_btn.innerText = "SOLD OUT";
      }
      // let productJson = JSON.parse(document.querySelector('.variant-quick-add-cart-js', parent).innerText);
      // if (document.querySelector('variant-radios', parent)) {
      //   document.querySelectorAll('variant-radios input:checked', parent).forEach(option => {
      //     options.push(option.value);
      //   });
      // }

      // let currentVariant = productJson?.variants?.find((variant) => {
      //   return !variant.options.map((option, index) => {
      //     return options[index] === option;
      //   }).includes(false);
      // });

      // if (!currentVariant) {
      //   console.log('current variant not found');
      //   return;
      // }
      
      // console.log('currentVariant', currentVariant);
      // let addToCartBtn = document.querySelector('.variant-quick-add-cart-js', parent);
      // let isVariantAvailable = false;
      // if(currentVariant?.available == true) {
      //   isVariantAvailable = true;
      // }
      // addToCartBtn.setAttribute('data-price', currentVariant?.price);
      // addToCartBtn.setAttribute('data-vid', currentVariant?.id);
      // if(isVariantAvailable) {
      //   addToCartBtn.removeAttribute('disabled');
      //   // addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "ADD TO CART";
      //   addToCartBtn.innerText = "ADD TO CART";
      // }
      // else {
      //   addToCartBtn.setAttribute('disabled', '');
      //   // addToCartBtn.querySelector(".product-card--add-to-cart-text").innerText = "SOLD OUT";
      //   addToCartBtn.innerText = "SOLD OUT";
      // }
    };
const changeEvent = (data) => {
      let parent = data;
      if (!parent) {
        return;
      }
      if (document.querySelector("variant-radios input", parent)) {
        document.querySelectorAll("variant-radios input", parent).forEach(item => {
          item.addEventListener('change', (e) => {
            document.querySelectorAll('variant-radios input',parent).forEach(option => {
              option.closest('.option-list').classList.remove('selected');
            });
            document.querySelectorAll('variant-radios input:checked', parent).forEach(option => {
              option.closest('.option-list').classList.add('selected');
            });
            // console.log("Parent", parent, parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset .option-list"), parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset .option-list").length);
            if(parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset .option-list") && parent.querySelectorAll(".multi-variant-popup-wrapper.active.open variant-radios fieldset .option-list").length > 1) {
              variantChange(parent);
            } else {
              let addToCartBtn = parent.querySelector('.variant-quick-add-cart-js');
              let isVariantAvailable = false;
              if(item.getAttribute("is-available") == "true") {
                isVariantAvailable = true;
              }
              let price = item.getAttribute('data-price');
              addToCartBtn.setAttribute('data-price', price);
              let vId = item.getAttribute('data-vid');
              addToCartBtn.setAttribute('data-vid', vId);
              if(isVariantAvailable) {
                addToCartBtn.removeAttribute('disabled');
                // addToCartBtn.querySelector(".multi-variant-popup-wrapper .button-wrapper button").innerText = "ADD TO CART";
                addToCartBtn.innerText = "ADD TO CART";
              }
              else {
                addToCartBtn.setAttribute('disabled', '');
                // addToCartBtn.querySelector(".multi-variant-popup-wrapper .button-wrapper button").innerText = "SOLD OUT";
                addToCartBtn.innerText = "SOLD OUT";
              }
            }
          })
        })
      }
    };
const fetchProductDetails = (productUrl, button, event) => {
       
  fetch(productUrl)
  .then((response) => response.text())
  .then((responseText) => {
    const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
    const sectionWrapper = button.closest('.button-wrapper');
    // console.log("sectionWrapper",sectionWrapper);
    
    if (sectionWrapper) {
      
      const popupWrapper = sectionWrapper.querySelector('.multi-variant-popup-wrapper');
      const productDetails = responseHTML.querySelector('.multi-variant-popup-content');
      // console.log("productDetails", productDetails);
      if (popupWrapper && productDetails) {
        const popupContent = popupWrapper.querySelector('.multi-variant-popup-content');
        if (popupContent) {
          popupContent.innerHTML = productDetails.innerHTML;
          
          document.querySelector("html.js").style.overflow = "hidden";
          popupWrapper.classList.add('active');
          
          if(productDetails.querySelectorAll('variant-radios fieldset').length > 1 || productDetails.querySelectorAll(".options-wrapper .option-list").length > 4) {
            popupWrapper.querySelector(".multi-variant-popup-inner").classList.add("fix-height-popup");
          } else {
            popupWrapper.querySelector(".multi-variant-popup-inner").classList.remove("fix-height-popup");
          }

          setTimeout(() => {
            popupWrapper.classList.add('open');
          }, 200);
          button.classList.remove('btn-loading');
          changeEvent(popupWrapper);
          
        }
      }
    }
  })
  .catch((error) => {
    // console.error('Error fetching product details:', error);
  });
};
const productInformation = [
  {
    "tag": "oily_skin",
    "iconImage": "https://cdn.shopify.com/s/files/1/0024/0818/5901/files/info-img1.png?v=1662959092",
    "text": "Good for Oily Skin"
  },
  {
    "tag": "sulphate_free",
    "iconImage": "https://cdn.shopify.com/s/files/1/0024/0818/5901/files/info-img2.png?v=1662959092",
    "text": "Sulphate Free"
  },
  {
    "tag": "moustache_growth",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Moustache_Growth.svg?v=1669207407",
    "text": "Moustache Growth"
  },
  {
    "tag": "beard_styling",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Beard_Styling_1.svg?v=1669207407",
    "text": "Beard Styling"
  },
  {
    "tag": "hair_&_beard_growth",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Hair___Beard_Growth.svg?v=1669207407",
    "text": "Hair & Beard Growth"
  },
  {
    "tag": "hair_styling",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Hair_Styling.svg?v=1669207407",
    "text": "Hair Styling"
  },
  {
    "tag": "deep_cleansing",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Deep_Cleansing.svg?v=1669207407",
    "text": "Deep Cleansing"
  },
  {
    "tag": "treats_dry_heels",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Treats_Dry_Heels.svg?v=1669207407",
    "text": "Treats Dry Heels"
  },
  {
    "tag": "intimate_hygiene",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Intimate_Hygiene.svg?v=1669207407",
    "text": "Intimate Hygiene"
  },
  {
    "tag": "moisturises",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Moisturises.svg?v=1669207407",
    "text": "Moisturises"
  },
  {
    "tag": "cleanses",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Cleanses.svg?v=1669207407",
    "text": "Cleanses"
  },
  {
    "tag": "dermatologically_tested",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Dermatologically_Tested.svg?v=1669207407",
    "text": "Dermatologically Tested"
  },
  {
    "tag": "detoxifies",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Detoxifies.svg?v=1669207407",
    "text": "Detoxifies"
  },
  {
    "tag": "purifies",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Purifies.svg?v=1669207407",
    "text": "Purifies"
  },
  {
    "tag": "de_stresses",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/De-stresses.svg?v=1669207407",
    "text": "De-stresses"
  },
  {
    "tag": "evens_tone",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Evens_Tone.svg?v=1669207407",
    "text": "Evens Tone"
  },
  {
    "tag": "for_acne_prone_skin",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/For_Acne_Prone_Skin.svg?v=1669207407",
    "text": "For Acne Prone Skin"
  },
  {
    "tag": "deep_cleanses",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Deep_Cleanses.svg?v=1669207407",
    "text": "Deep Cleanses"
  },
  {
    "tag": "hydrates",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Hydrates.svg?v=1670840367",
    "text": "Hydrates"
  },
  {
    "tag": "boosts_collagen",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Boosts_Collagen.svg?v=1669207407",
    "text": "Boosts Collagen"
  },
  {
    "tag": "unclogsc_Pores",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Unclogs_Pores.svg?v=1669207407",
    "text": "Unclogs Pores"
  },
  {
    "tag": "moisturises_lips",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Moisturises_Lips.svg?v=1669207407",
    "text": "Moisturises Lips"
  },
  {
    "tag": "lightens_lips",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Lightens_Lips.svg?v=1669207407",
    "text": "Lightens Lips"
  },
  {
    "tag": "instant_glow",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Instant_Glow.svg?v=1669207407",
    "text": "Instant Glow"
  },
  {
    "tag": "minimises_pores",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Minimises_Pores.svg?v=1669207407",
    "text": "Minimises Pores"
  },
  {
    "tag": "suitable_for_all_skin_types",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Suitable_for_All_Skin_Types.svg?v=1669207407",
    "text": "Suitable for All Skin Types"
  },
  {
    "tag": "removes_blackheads_&_excess_oil",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Removes_Blackheads___Excess_Oil.svg?v=1669207407",
    "text": "Removes Blackheads & Excess Oil"
  },
  {
    "tag": "hair_growth",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Hair_Growth.svg?v=1669207407",
    "text": "Hair Growth"
  },
  {
    "tag": "repairs_uv_damage",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Repairs_UV_Damage.svg?v=1669207407",
    "text": "Repairs UV Damage"
  },
  {
    "tag": "reduces_dark_circles",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Reduces_Dark_Circles.svg?v=1669207407",
    "text": "Reduces Dark Circles"
  },
  {
    "tag": "blue_light_technology_&_uva_uvb_protection",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Blue_Light_Technology___UVA-UVB_Protection.svg?v=1669207407",
    "text": "Blue Light Technology & UVA/UVB Protection"
  },
  {
    "tag": "improves_skin_barrier",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Improves_Skin_Barrier.svg?v=1669207408",
    "text": "Improves Skin Barrier"
  },
  {
    "tag": "refreshes",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Refreshes.svg?v=1669207407",
    "text": "Refreshes"
  },
  {
    "tag": "72_hours_hydration",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/72_Hours_Hydration.svg?v=1669207407",
    "text": "72 Hours Hydration"
  },
  {
    "tag": "long_lasting_fragrance",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Long-Lasting_Fragrance.svg?v=1669207407",
    "text": "Long-Lasting Fragrance"
  },
  {
    "tag": "long-lasting_freshness_&_no_gas_perfume",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Long-Lasting_Freshness_No_-_Gas_Perfume.svg?v=1670917806",
    "text": "Long-Lasting Freshness & No - Gas Perfume"
  },
  {
    "tag": "instant_freshness_&_controls_body_odour",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Instant_Freshness___Controls_Body_Odour.svg?v=1669207407",
    "text": "Instant Freshness & Controls Body Odour"
  },
  {
    "tag": "premium_lasting_fragrance",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Premium_Lasting_Fragrance.svg?v=1669207407",
    "text": "Premium Lasting Fragrance"
  },
  {
    "tag": "24_hours_freshness_&_combats_body_odour",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/24_Hours_Freshness___Combats_Body_Odour.svg?v=1669207407",
    "text": "24 Hours Freshness & Combats Body Odour"
  },
  {
    "tag": "hair_care",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Hair_Care.svg?v=1669207407",
    "text": "Hair Care"
  },
  {
    "tag": "dandruff_&_hair_fall",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Dandruff___Hair_Fall.svg?v=1669207407",
    "text": "Dandruff & Hair Fall"
  },
  {
    "tag": "razor_burns_&_clean_shaving_experience",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Razor_Burns_Clean_Shaving_Experience.svg?v=1670917806",
    "text": "Razor Burns & Clean Shaving Experience"
  },
  {
    "tag": "razor_burns_&_cuts",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Razor_Burns___Cuts.svg?v=1669207407",
    "text": "Razor Burns & Cuts"
  },
  {
    "tag": "premium_shaving_brush",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Premium_Shaving_Brush.svg?v=1669207407",
    "text": "Premium Shaving Brush"
  },
  {
    "tag": "heals_cuts_&_razor_burns",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Heals_Cuts___Razor_Burns.svg?v=1669207407",
    "text": "Heals Cuts & Razor Burns"
  },
  {
    "tag": "untangles_&_styles",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Untangles___Styles.svg?v=1669207407",
    "text": "Untangles & Styles"
  },
  {
    "tag": "stimulates_hair_growth",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Stimulates_Hair_Growth.svg?v=1669207407",
    "text": "Stimulates Hair Growth"
  },
  {
    "tag": "premium_quality",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Premium_Quality.svg?v=1669207407",
    "text": "Premium Quality"
  },
  {
    "tag": "ideal_for_gifting",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_For_Gifting.svg?v=1669207407",
    "text": "Ideal For Gifting"
  },
  {
    "tag": "ideal_for_gifting_&_daily_regime",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_For_Gifting___Daily_Regime.svg?v=1669207407",
    "text": "Ideal For Gifting & Daily Regime"
  },
  {
    "tag": "ideal_for_beard_lovers",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_For_Beard_Lovers.svg?v=1669207407",
    "text": "Ideal For Beard Lovers"
  },
  {
    "tag": "ideal_for_fragrance_lovers",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_For_Fragrance_Lovers.svg?v=1669207407",
    "text": "Ideal For Fragrance Lovers"
  },
  {
    "tag": "ideal_gift_for_skincare_lovers",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_Gift_For_Skincare_Lovers.svg?v=1669207407",
    "text": "Ideal Gift For Skincare Lovers"
  },
  {
    "tag": "body_care_&_gentle_cleansing",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Body_Care___Gentle_Cleansing.svg?v=1669207407",
    "text": "Body Care & Gentle Cleansing"
  },
  {
    "tag": "gentle_bath_care",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Gentle_Bath_Care.svg?v=1669207407",
    "text": "Gentle Bath Care"
  },
  {
    "tag": "go_to_gift",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Go-To_Gift.svg?v=1669207407",
    "text": "Go-To Gift"
  },
  {
    "tag": "ideal_gift_for_shaving_enthusiasts",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_Gift_For_Shaving_Enthusiasts.svg?v=1669207407",
    "text": "Ideal Gift For Shaving Enthusiasts"
  },
  {
    "tag": "ideal_gift_for_hair_care_devotees",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Ideal_Gift_For_Hair_Care_Devotees.svg?v=1669207407",
    "text": "Ideal Gift For Hair Care Devotees"
  },
  {
    "tag": "2_in_1_shampoo_conditioner",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/2_in_1.svg?v=1672988434",
    "text": "2 in 1 Shampoo+Conditioner"
  },
  {
    "tag": "ideal_for_gray_hair",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/gray_hair.svg?v=1672988434",
    "text": "Ideal for Grey Hair"
  },
  {
    "tag": "beard_care",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Beard_Care.svg?v=1669207407",
    "text": "Beard Care"
  },
  {
    "tag": "3x_softer",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/3x_softer.svg?v=1673851816",
    "text": "3x Softer"
  },
  {
    "tag": "sweat_&_odour_free",
    "iconImage": "https://cdn.shopify.com/s/files/1/1188/2592/files/Sweat_odour-free.svg?v=1673851816",
    "text": "Sweat & Odour-free"
  }
  // ... continue the rest in same format
];
const interval = setInterval(() => {
        if (window.wizzyConfig && window.wizzyConfig.common) {
            clearInterval(interval);

            

            // if (window.innerWidth > 768) {
            //     window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            //         {
            //             dom: ".search-modal .search__input.field__input.wizzy-search-input",
            //             type: "search"
            //         }
            //     ];
            // } else {
            //     window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
            //         {
            //             dom: ".mobile-search .search__input.field__input.wizzy-search-input",
            //             type: "search"
            //         }
            //         // ,
            //         // {
            //         //     dom: ".form.minisearch .wizzy-search-form input",
            //         //     type: "text"
            //         // }
            //     ];
            // }
            if(window.innerWidth > 768)
            {
              window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                  dom: ".search-modal .search__input.field__input",
                  type: "search"
                }
              ];
            }
            else{
              window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers = [
                {
                  dom: ".mobile-search .search__input.field__input",
                  type: "search"
                },
                {
                  dom: ".form.minisearch .wizzy-search-form input",
                  type: "text"
                },
              ];
            }

            // console.log("Wizzy searchInputIdentifiers set:", window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers);
        }
    }, 100);
// $(document).on("click", ".search-modal .search__input.field__input.wizzy-search-input", function () {
    
//     if(window.wizzyLazyAssetUtils && !window.wizzyLazyAssetUtils.isWizzyLazyLoaded){
//       window?.wizzyLazyAssets?.load();
//       window.wizzyLazyAssetUtils.isWizzyLazyLoaded = true;
//     }
   
// });
window.onWizzyScriptLoaded = function () {
    $(document).on('click', '.quick-add-modal__toggle', function () {
      if (window.innerWidth > 768) {
        $('.wizzy-autocomplete-wrapper').hide();
      }
    });
    $(document).on('click', '.wizzy-autocomplete-wrapper', function () {
        if (window.innerWidth > 768) {
          if ($(e.target).closest('.quick-add, .model-opener').length) {
            setTimeout(() => {
            $(this).hide();
            }, 1000)
          }
            
        }
        // else
        // {
        //   let close_btn = document.querySelector('.wizzy-search-back');
        //   if(close_btn)
        //   {
        //     close_btn.click();
        //   }
        // }
    });
    $(document).on('click', '.wizzy-autocomplete-wrapper .quick-add product-form', function () {
      if (window.innerWidth > 768) {
        $('.wizzy-autocomplete-wrapper').css('display', 'none');
      }
      else
      {
        let close_btn = document.querySelector('.wizzy-search-back');
        if(close_btn)
        {
          setTimeout(() => {
            close_btn.click();
          }, 500)
          
        }
      }
  });
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (products) {
        try {
            
        if (!window.productDescriptionMap) {
          window.productDescriptionMap = {};
        }
        // console.log("AFTER_PRODUCTS_TRANSFORMED : ",products);
        products.forEach((product) => {
            let attributes = product.attributes;
            if(attributes)
            {

            product.product_info = [];
            attributes.forEach((attr) => {
                if(attr.id === "product_tags")
                {
                    let values = attr.values[0].value[0];
                    const tags = values.split(",").map(tag => tag.trim());
                    for (let i = 0; i < tags.length; i++) {
                        if (tags[i].includes("category_")) {
                            const product_tag = tags[i].replace("category_", "");
                            product.tag = product_tag;
                        }
                        else if(tags[i] === 'best_seller')
                        {
                            product.best_seller = true;
                        }
                        else if(tags[i] === 'New Launches')
                        {
                            product.new_launches = true;
                        }
                        else if(tags[i] === 'Must_Have')
                        {
                            product.must_have = true;
                        }
                        else if(tags[i] === 'gog_sale')
                        {
                            product.gog_sale = true;
                        }
                        else if(tags[i] === 'buy_get_one')
                        {
                            product.buy_get_one = true;
                        }
                        else if(tags[i] === '3_at_499')
                        {
                            product.three_at_499 = true;
                        }
                        else if(tags[i] === '1_at_199')
                        {
                            product.one_at_199 = true;
                        }
                        else if(tags[i] === 'fragrance_fest')
                        {
                            product.fragrance_fest = true;
                        }
                        else if(productInformation.find(item => item.tag === tags[i]))
                        {
                          const info = productInformation.find(item => item.tag === tags[i]);
                          product.product_info.push(info)
                        }
                    }
                }
                else if(attr.id === 'product_description_tag_global')
                {
                    product.description_tag = attr.values[0].value[0];
                }
                else if(attr.id === "product_handle")
                {
                    product.product_handle = attr.values[0].value[0];
                }
                else if(attr.id === "product_variant_prices")
                {
                    let values = attr.values;
                    if(values.length > 1)
                    {
                        product.hasVariants = true;
                    }
                }
                else if(attr.id === "product_rating_reviews")
                {
                  let rev = attr.values[0].value[0];
                  let obj = JSON.parse(rev);
                  let value = parseFloat(obj.value);
                  let normalized = parseFloat(value.toFixed(1)); 
                  if (normalized !== 0) {
                    product.avg_review = normalized;
                  }
                }
                else if(attr.id === "product_handle")
                {
                  product.handle = attr.values[0].value[0];
                }
            })
          }
          product.sellingPrice = product.sellingPrice.split(".")[0];
          product.price = product.price.split(".")[0];
          if(!product.description_tag)
          {
            fetch(`https://www.themancompany.com/products/${product.product_handle}.js`)
          .then(res => res.json())  // parse the JSON response
          .then(product_data => {
            // Access the description
            // console.log("product", product_data);
            let rawDescription = product_data.description;  // this is the Shopify product description (HTML)
            rawDescription = rawDescription.replace(/<!--[\s\S]*?-->/g, '');
            // Optional: strip HTML to get plain text
            let tempDiv = document.createElement('div');
            tempDiv.innerHTML = rawDescription;
            let cleanText = tempDiv.textContent || tempDiv.innerText || '';
            
            // console.log("Plain text description:", cleanText);
            window.productDescriptionMap[product.id] = cleanText;
          })
          .catch(err => {});
          }
          

          // console.log("for loop ends");
            
        })
        
        } catch (error) {
            // console.log("error", error);
        }
        return products;
      }
  );
  function handleCloseBtnClick() {
    let sort_btn = document.querySelector('.wizzy-common-select-selector');
    if(sort_btn)
      sort_btn.click();
  }
  function handleButtonClickForInstock() {
      let input_ele = document.querySelector('.facet-body-inStock .wizzy-input-toggle-button input');
      if(input_ele)
      {
        if(input_ele.hasAttribute("checked"))
        {
          input_ele.removeAttribute('checked');
        }
        else
        {
          input_ele.setAttribute('checked', '');
        }
      }
      const currentURL = window.location.href
        , updatedURL = updateURL(currentURL, "inStock[]", "true");
      window.executeWizzyFiltersFromURL(updatedURL)
  }
  function updateURL(url, key, value) {
      const urlObj = new URL(url);
      urlObj.searchParams.has(key) ? urlObj.searchParams.delete(key) : urlObj.searchParams.append(key, value);
      var newURL = urlObj.toString().replace(/%5B%5D/g, "[]");
      return newURL
  }
  
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (data) {
         window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        //  console.log("BEFORE_LAZY_INIT", data);
        //  if(window.innerWidth > 768)
        //  {
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [
        //     {
        //       dom: ".st-desktop-searchbox .wizzy-custom-search-input",
        //       type: "text"
        //     }
        //   ];
        //  }
        //  else{
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [
        //     {
        //       dom: ".st-mobile-searchbox .wizzy-custom-search-input, .form.minisearch .wizzy-search-form input",
        //       type: "text"
        //     },
        //   ];
        //  }
        // if(window.innerWidth > 768)
        //  {
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [
        //     {
        //       dom: ".search-modal .search__input.field__input.wizzy-search-input",
        //       type: "search"
        //     }
        //   ];
        //  }
        //  else{
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [
        //     {
        //       dom: ".mobile-search .search__input.field__input.wizzy-search-input",
        //       type: "search"
        //     },
        //     {
        //       dom: ".form.minisearch .wizzy-search-form input",
        //       type: "text"
        //     },
        //   ];
        //  }
        if(window.innerWidth > 768)
         {
          data.common.lazyDOMConfig.searchInputIdentifiers = [
            {
              dom: ".search-modal .search__input.field__input",
              type: "search"
            }
          ];
         }
         else{
          data.common.lazyDOMConfig.searchInputIdentifiers = [
            {
              dom: ".mobile-search .search__input.field__input",
              type: "search"
            },
            {
              dom: ".form.minisearch .wizzy-search-form input",
              type: "search"
            },
          ];
         }
        return data;
      });
  window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (data) {
        // console.log("BEFORE_INIT", data);
         window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
        //  if(window.innerWidth > 768)
        //  {
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [
        //     {
        //       dom: ".st-desktop-searchbox .wizzy-custom-search-input",
        //       type: "text"
        //     }
        //   ];
        //  }
        //  else{
        //   data.common.lazyDOMConfig.searchInputIdentifiers = [
        //     {
        //       dom: ".st-mobile-searchbox .wizzy-custom-search-input",
        //       type: "text"
        //     },
        //     {
        //       dom: ".form.minisearch .wizzy-search-form input",
        //       type: "text"
        //     },
        //   ];
        //  }
        window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
          desktop: 3e3,
          mobile: 5e3,
        };
        if(window.innerWidth > 768)
         {
          data.common.lazyDOMConfig.searchInputIdentifiers = [
            {
              dom: ".search-modal .search__input.field__input.wizzy-search-input",
              type: "search"
            }
          ];
         }
         else{
          data.common.lazyDOMConfig.searchInputIdentifiers = [
            {
              dom: ".mobile-search .search__input.field__input.wizzy-search-input",
              type: "search"
            },
            {
              dom: ".form.minisearch .wizzy-search-form input",
              type: "search"
            },
          ];
         }
        return data;
      });
      window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (data) {
        delete window.productDescriptionMap;
        return data;
      });
      window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function (data) {
        // console.log("BEFORE_RENDER_RESULTS", data);
        if (data.api === "search" || data.api === "filter") {
            const unwanted = ["2 options available", "3 options available", "4 options available", "5 options available", "6 options available"]; // make lowercase for safe compare

            if (data && data.response && data.response.payload && Array.isArray(data.response.payload.facets)) {
                data.response.payload.facets.forEach(facet => {
                    if (facet.key === "product_category_tags" && Array.isArray(facet.data)) {
                        facet.data = facet.data.filter(item => {
                            const label = (item.label || "").toLowerCase();
                            return !unwanted.includes(label);
                        });
                    }
                });
            }
        }
        // console.log("returning from render results");
        return data;
      });
      window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (data) {
        delete window.productDescriptionMap;
        let mobile_search_form = document.querySelector('.form.minisearch');
        if(mobile_search_form)
        {
          mobile_search_form.style.display = "none";
        }
        let back_btn = document.querySelector('.wizzy-search-form-wrapper.mobileTapped .wizzy-search-back');
        if(back_btn)
        {
          back_btn.click();
        }
        return data;
      });
      function updateDescriptionsWithRetry(maxTries = 10, delay = 500) {
  let tries = 0;

  const interval = setInterval(() => {
    tries++;

    if (window.productDescriptionMap && Object.keys(window.productDescriptionMap).length) {
      // console.log("✅ productDescriptionMap found, updating DOM...");

      Object.entries(window.productDescriptionMap).forEach(([productId, cleanText]) => {
        const el = document.querySelector(`.wizzy-result-product[data-id="${productId}"]`);
        if (!el) {
          // console.log("Product not found", productId);
          return;
        };

        const description = el.querySelector('.product-description .text-description');
        if (description) description.textContent = cleanText;
      });

      // Clean up global variable and stop retrying
      // delete window.productDescriptionMap;
      clearInterval(interval);
      // console.log("🎉 Done updating. Removed productDescriptionMap.");
    } else if (tries >= maxTries) {
        clearInterval(interval);
        // console.warn("⏳ Gave up: productDescriptionMap not ready after max tries.");
      } else {
        // console.log(`Retrying... attempt ${tries}`);
      }
    }, delay);
  }

   window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (data) {
        const quickAddModals = document.querySelectorAll('.quick-add-modal');
        const stickyHeader = document.querySelector('sticky-header');

        const observer = new MutationObserver(() => {
            const isAnyModalOpen = Array.from(quickAddModals).some(modal =>
                modal.hasAttribute('open')
            );

            stickyHeader.style.display = isAnyModalOpen ? 'none' : '';
        });

        quickAddModals.forEach(modal => {
            observer.observe(modal, {
                attributes: true,
                attributeFilter: ['open']
            });
        });
        // Loop through the productDescriptionMap
        setTimeout(() => {
          updateDescriptionsWithRetry(20, 1000);
        }, 3500);
        
        if(window.innerWidth < 768){
          const wrapper = document.querySelector(".wizzy-search-summary-container");

          if (wrapper && wrapper.innerHTML.trim() === "") {
            const total = data?.data?.response?.payload?.total || 0;
            const query = data?.data?.response?.payload?.filters?.q || "";

            wrapper.innerHTML = `
              <p class="wizzy-summary-head">${total} Results found for <strong>"${query}"</strong>:</p>
            `;
          }
        }
        // let inStockbtn = document.querySelector('.facet-body-inStock .custom-toggle label');
        // if(inStockbtn)
        // {
        //   inStockbtn.addEventListener('click', handleButtonClickForInstock);
        // }
        let sort_btn = document.querySelector('.wizzy-common-select-selector');
        if(sort_btn)
        {
          sort_btn.addEventListener('click', function(){
            setTimeout(() => {
              let close_btn = document.querySelector('.wizzy-common-select-options.title-mobile');
              if(close_btn)
              {
                close_btn.removeEventListener('click', handleCloseBtnClick);
                close_btn.addEventListener('click', handleCloseBtnClick);
              }
            }, 300);
          })
        }
        // console.log("view_render 1");
// document.querySelectorAll(".wizzy-result-product .button-wrapper button.btn-primary").forEach(function (btn) {
//       btn.addEventListener("click", function (e) {
//         e.preventDefault();
//         e.stopPropagation();

//         // Prevent double clicks
//         if (btn.classList.contains('btn-loading')) return;
//         if (btn.classList.contains('disabled')) return;
//         const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

//         btn.classList.add('btn-loading');

        

//         if (isPopupTrigger) {
//           const productUrl = btn.dataset.vid;
//           if (productUrl) {
//             const url = `/products/${productUrl}?section_id=quick-add-product`;
//             // console.log("Inside isPopup trigger");
            
//             fetchProductDetails(url, btn, e);
//           }
//         } else {
//           const ID = btn.getAttribute("data-vid");
//           addToCart(ID, 1, btn);
//         }
//       });
//     });
    // document.addEventListener('click', function(e){

    //   if(e.target.matches('.multi-variant-popup-wrapper .button-wrapper button'))
    //   {
    //     let btn = e.target.closest('.multi-variant-popup-wrapper .button-wrapper button');
    //     const ID = btn.getAttribute("data-vid");
        
    //     e.target.classList.add('btn-loading');
    //     addToCart(ID, 1, btn);
        
    //   }
    //   else if(e.target.matches('.multi-popup-close'))
    //   {
    //     let wrapper = document.querySelector('.multi-variant-popup-wrapper.open.active')
    //     if(wrapper)
    //     {
    //       wrapper.classList.remove('open');
    //       wrapper.classList.remove('active');
    //       document.documentElement.style.overflow = "auto";
    //     }
    //   }
    //   else if(e.target.matches('.wizzy-search-back'))
    //   {
    //     let mobile_search_form = document.querySelector('.form.minisearch');
    //     if(mobile_search_form)
    //     {
    //       mobile_search_form.style.display = "none";
    //     }
    //   }
    // })
    // console.log("view_render 2")
    // var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
    //     if (instockValue && instockValue[0] === "true") {
    //         var inputForInstock = document.querySelector(".facet-body-inStock .wizzy-input-toggle-button input")
    //           , inputForInstockMobile = document.querySelector(".wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class");
    //         inputForInstock && inputForInstock.setAttribute("checked", ""),
    //         inputForInstockMobile && inputForInstockMobile.setAttribute("checked", "")
    //     }
        gridFiltersToggleOnOverflow();
        // console.log("view_render 3");
        return data;
      });
      
       window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (data) {
        // Loop through the productDescriptionMap
        updateDescriptionsWithRetry(20, 500);
        if(window.innerWidth < 768){
          const wrapper = document.querySelector(".wizzy-search-summary-container");

          if (wrapper && wrapper.innerHTML.trim() === "") {
            const total = data?.data?.response?.payload?.total || 0;
            const query = data?.data?.response?.payload?.filters?.q || "";

            wrapper.innerHTML = `
              <p class="wizzy-summary-head">${total} Results found for <strong>"${query}"</strong>:</p>
            `;
          }
        }
        let inStockbtn = document.querySelector('.facet-body-inStock .custom-toggle label');
        if(inStockbtn)
        {
          inStockbtn.addEventListener('click', handleButtonClickForInstock);
        }
        let sort_btn = document.querySelector('.wizzy-common-select-selector');
        if(sort_btn)
        {
          sort_btn.addEventListener('click', function(){
            setTimeout(() => {
              let close_btn = document.querySelector('.wizzy-common-select-options.title-mobile');
              if(close_btn)
              {
                close_btn.removeEventListener('click', handleCloseBtnClick);
                close_btn.addEventListener('click', handleCloseBtnClick);
              }
            }, 300);
          })
        }

document.querySelectorAll(".wizzy-result-product .button-wrapper button.btn-primary").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Prevent double clicks
        if (btn.classList.contains('btn-loading')) return;
        if (btn.classList.contains('disabled')) return;
        const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

        btn.classList.add('btn-loading');

        

        if (isPopupTrigger) {
          const productUrl = btn.dataset.vid;
          if (productUrl) {
            const url = `/products/${productUrl}?section_id=quick-add-product`;
            // console.log("Inside isPopup trigger");
            
            fetchProductDetails(url, btn, e);
          }
        } else {
          const ID = btn.getAttribute("data-vid");
          addToCart(ID, 1, btn);
        }
      });
    });
    document.addEventListener('click', function(e){
      if(e.target.matches('.multi-variant-popup-wrapper .button-wrapper button'))
      {
        let btn = e.target.closest('.multi-variant-popup-wrapper .button-wrapper button');
        const ID = btn.getAttribute("data-vid");
        
        e.target.classList.add('btn-loading');
        addToCart(ID, 1, btn);
        
      }
      else if(e.target.matches('.multi-popup-close'))
      {
        let wrapper = document.querySelector('.multi-variant-popup-wrapper.open.active')
        if(wrapper)
        {
          wrapper.classList.remove('open');
          wrapper.classList.remove('active');
          document.documentElement.style.overflow = "auto";
        }
      }
      else if(e.target.matches('.wizzy-search-back'))
      {
        let mobile_search_form = document.querySelector('.form.minisearch');
        if(mobile_search_form)
        {
          mobile_search_form.style.display = "none";
        }
      }
    })
    var instockValue = window.wizzyConfig?.pageStore?.searchedResponse?.filters?.inStock;
        if (instockValue && instockValue[0] === "true") {
            var inputForInstock = document.querySelector(".facet-body-inStock .wizzy-input-toggle-button input")
              , inputForInstockMobile = document.querySelector(".wizzy-filters-facet-block.facet-block-inStock .wizzy-search-filters-toggle-input-class");
            inputForInstock && inputForInstock.setAttribute("checked", ""),
            inputForInstockMobile && inputForInstockMobile.setAttribute("checked", "")
        }
        gridFiltersToggleOnOverflow();
        return data;
      });
    if(window.innerWidth <= 768)
    {
      const front_input = document.querySelector('.mobile-search .search__input.field__input.wizzy-search-input');
      
      // console.log("inside front and back", front_input);
      if(front_input)
      {
        // console.log("inside front and back");
        front_input.addEventListener("click", function(){
          // console.log("front clicked");
          const back_input = document.querySelector('#search_mini_form input');
          if(back_input)
            back_input.click();
          // back_input.click();
          // console.log(back_input);
          let search_form = document.querySelector('#search_mini_form');
          if(search_form)
          {
            search_form.style.display = "block";
            setTimeout(() => {
              let search_bar = search_form.querySelector("input");
              // console.log("SEARCH_BAR", search_bar);
              if(search_bar)
              {
                search_bar.click();
              }
            }, 300);
            
          }
          // let autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
          //   if(autocomplete)
          //   {
          //     autocomplete.style.top = "83px";
          //   }
        })
        
      }
    }

    function gridFiltersToggleOnOverflow() {
  if (window.innerWidth > 768) {
    const filterBoxes = document.querySelectorAll(".wizzy-grid-filters-box");

    if (filterBoxes.length > 0) {
      filterBoxes.forEach((box) => {
        const filterList = box.querySelector(
          ".wizzy-facet-body .wizzy-facet-list"
        );
        const toggleBtn = box.querySelector(
          ".wizzy-facet-body .wizzy-toggle-btn"
        );
        const filterOptions = box.querySelector(".wizzy-facet-body");

        if (
          filterList &&
          toggleBtn &&
          filterOptions &&
          !toggleBtn.classList.contains("wizzy-click-event-attached")
        ) {
          const filterHeight = filterList.offsetHeight;
          const lineHeight = parseFloat(
            getComputedStyle(filterList).lineHeight
          );
          const maxVisibleLines = 2;
          const visibleLines = parseInt((Math.floor(filterHeight / lineHeight) - 1) / 2);
          // console.log("visibleLines", visibleLines);
          if (visibleLines > maxVisibleLines) {
            filterOptions.classList.add("collapsed");
            toggleBtn.classList.add("wizzy-click-event-attached");
            toggleBtn.style.display = "inline-block";
          } else {
            toggleBtn.style.display = "none";
          }

          toggleBtn.addEventListener("click", function () {
            if (filterOptions.classList.contains("collapsed")) {
              filterOptions.classList.remove("collapsed");
              filterOptions.classList.add("expanded");
              toggleBtn.innerText = "- Less";
            } else {
              filterOptions.classList.remove("expanded");
              filterOptions.classList.add("collapsed");
              toggleBtn.innerText = "+ More";
            }
            toggleBtn.classList.add("wizzy-click-event-attached");
          });
        }
      });
    }
  }
}
const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
      if(window.innerWidth >= 768 && autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex")
      {
        const input = document.querySelector('.search__input.field__input.wizzy-search-input');
        const autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');

        if (input && autocomplete)
        {
          const rect = input.getBoundingClientRect();
          autocomplete.style.left = rect.left + 'px';
          autocomplete.style.width = rect.width + 'px';
        }
      }
      if(autocompleteElement)
      {
        document.querySelectorAll(".wizzy-result-product .button-wrapper button.btn-primary").forEach(function (btn) {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Prevent double clicks
            if (btn.classList.contains('btn-loading')) return;
            if (btn.classList.contains('disabled')) return;
            const isPopupTrigger = btn.classList.contains("variant-popup-js") || btn.querySelector(".variant-popup-js");

            btn.classList.add('btn-loading');
            if (isPopupTrigger) {
              const productUrl = btn.dataset.vid;
              if (productUrl) {
                const url = `/products/${productUrl}?section_id=quick-add-product`;
                // console.log("Inside isPopup trigger");
                
                fetchProductDetails(url, btn, e);
              }
            } else {
              const ID = btn.getAttribute("data-vid");
              addToCart(ID, 1, btn);
            }
          });
        });
      }
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());

}